import React from 'react';
import styled from 'styled-components';
import AccessoryItem from './accessoryItem';

function buildAccessoryItems(accessoryItems, info, prices, handleAddedToCart) {
    return accessoryItems?.map((ai, idx) => {

        const details = info?.itemDetailsBatch?.find(d => d.invMastUid === ai.associatedInvMastUid)
        const availability = info?.itemAvailability?.find(a => a.invMastUid === ai.associatedInvMastUid)
        const price = prices?.find(p => p.invMastUid === ai.associatedInvMastUid)

        return (
            <AccessoryItem
                key={idx}
                itemDetails={details}
                type={ai.type}
                availability={availability}
                price={price}
                handleAddedToCart={handleAddedToCart}
                isParentCalculateStock={true}
            />
        )
    })
}

const DivAccessoryItems = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
`
export default function Accessories(props) {
    const { items, 
            info,
            prices,
            handleAddedToCart
            } = props

    const Items = buildAccessoryItems(items, info, prices, handleAddedToCart )
    
    return (
        <DivAccessoryItems>
            {Items}
        </DivAccessoryItems>
    )
}